import { useAuthentication } from 'hooks/useAuthentication'
import React from 'react'
import { Link } from 'react-router-dom'

export default function FotoPerfilMenu() {
  const { setIsAuth } = useAuthentication()

  const handleLogout = () => {
    window.localStorage.removeItem('__atk__')
    setIsAuth(false)
  }

  return (
    <li className='nav-item dropdown no-arrow'>
      <span
        className='nav-link dropdown-toggle'
        id='userDropdown'
        role='button'
        data-toggle='dropdown'
        aria-haspopup='true'
        aria-expanded='false'
      >
        <span className='mr-2 d-none d-lg-inline text-gray-600 small'>
          Valerie Luna
        </span>
        <img
          className='img-profile rounded-circle'
          src='https://source.unsplash.com/QAB-WJcbgJk/60x60'
          alt=''
        />
      </span>

      <div
        className='dropdown-menu dropdown-menu-right shadow animated--grow-in'
        aria-labelledby='userDropdown'
      >
        <Link className='dropdown-item' to='#'>
          <i className='fas fa-user fa-sm fa-fw mr-2 text-gray-400'></i>
          Profile
        </Link>
        <Link className='dropdown-item' to='#'>
          <i className='fas fa-cogs fa-sm fa-fw mr-2 text-gray-400'></i>
          Settings
        </Link>
        <Link className='dropdown-item' to='#'>
          <i className='fas fa-list fa-sm fa-fw mr-2 text-gray-400'></i>
          Activity Log
        </Link>
        <div className='dropdown-divider'></div>
        <Link
          className='dropdown-item'
          to='#'
          data-toggle='modal'
          data-target='#logoutModal'
          onClick={handleLogout}
        >
          <i className='fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400'></i>
          Salir
        </Link>
      </div>
    </li>
  )
}
